/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 * Page Reports Constructor component
 *
 * @author Evgeniy Naumov
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import { FC } from 'react';

import { useHistory } from 'react-router-dom';

import { LinkBlock, PageTitle } from '@components/common';
import { IPageReportsConstructorTranslation } from '@modules/internationalization/types/pages/reportsConstructor';
import { RoutePath } from '@routes/constants/routesConstants';
import { stringFormat } from '@utils/stringFormat';

import {
    ConstructorBasketSelectedStyled,
    ConstructorBasketStyled,
    ConstructorHeaderStyled,
    ConstructorBasketWrapperStyled,
    ConstructorBasketSubscribersStyled,
} from './styled/ConstructorHeaderStyled';

interface IConstructorHeaderProps {
    translation: IPageReportsConstructorTranslation;
    subscribersInBasket: number;
}

const ConstructorHeader: FC<IConstructorHeaderProps> = ({ translation, subscribersInBasket }) => {
    const history = useHistory();
    const { basket: tBasket } = translation.header;

    const handleOnCLick = () => {
        history.push(RoutePath.reportsConstructorSubscriber);
    };

    return (
        <ConstructorHeaderStyled>
            <PageTitle title={translation.header.title} />
            <ConstructorBasketWrapperStyled>
                <ConstructorBasketStyled>
                    <ConstructorBasketSelectedStyled>{tBasket.selected}</ConstructorBasketSelectedStyled>
                    <ConstructorBasketSubscribersStyled empty={subscribersInBasket === 0}>{`${stringFormat(
                        tBasket.subscribers,
                        subscribersInBasket,
                    )}`}</ConstructorBasketSubscribersStyled>
                    <LinkBlock
                        onClick={handleOnCLick}
                    >
                        {tBasket.changeLinkTitle}
                    </LinkBlock>
                </ConstructorBasketStyled>
            </ConstructorBasketWrapperStyled>
        </ConstructorHeaderStyled>
    );
};

export default ConstructorHeader;
